import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m17 3-5 5-5-5h10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m17 21-5-5-5 5h10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 12H2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 12H8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 12h-2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M22 12h-2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FlipVertical2";
const FlipVertical2 = memo(themed(Icon));
export {
  FlipVertical2
};
//# sourceMappingURL=flip-vertical-2.js.map
